import { RouteFrameCode } from 'components/common/types/Deal.types';
import SelectOption from 'lib/SelectOption';
import { useSelector } from 'react-redux';
import { getIsReseller } from 'store/publisher/selectors';

export type FetchedOptionsListProps = {
  code: string;
  name: string;
  mediaOwner?: string;
  onOptionIncludeExcludeChange: (routeFrameCode: RouteFrameCode) => void;
  isOptionIncluded: (code: string, mediaOwner?: string) => boolean | undefined;
  isOptionSelected: (code: string, mediaOwner?: string) => boolean;
};

const FetchedOptionsList: React.FC<FetchedOptionsListProps> = ({
  code,
  name,
  mediaOwner,
  onOptionIncludeExcludeChange,
  isOptionIncluded,
  isOptionSelected,
}) => {
  const isReseller = useSelector(getIsReseller);

  return (
    <div
      data-test-id="route-frame-codes-fetched-options"
      key={`select-route-frame-code-${code}`}
      className="border-b border-neutral-950-opacity-10 last:border-b-0"
    >
      <SelectOption
        value={{
          code,
          name,
          mediaOwner,
          include: isOptionIncluded(code, mediaOwner),
        }}
        isSelected={isOptionSelected(code, mediaOwner)}
        isDisabled={false}
        hasCheckbox={false}
        isMultiple
        isIncludeExcludeAlwaysVisible
        onIncludeExcludeChange={onOptionIncludeExcludeChange}
      >
        <div>
          {isReseller && mediaOwner && <div>{mediaOwner}:</div>}
          <div>{name}</div>
        </div>
      </SelectOption>
    </div>
  );
};

export default FetchedOptionsList;
